import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

type IconProps = {
  icon: IconDefinition;
} & React.HTMLAttributes<HTMLDivElement>
& FontAwesomeIconProps;

export function Icon({ icon, ...rest }: IconProps) {
  return <FontAwesomeIcon icon={icon} {...rest} />;
}
